/*
 * FS | Companion offer — instant add for the "Buy X, get Y% off Z" panels.
 *
 * One delegated click handler so it keeps working inside the cart drawer after its
 * innerHTML re-renders. Adds the button's items via /cart/add.js, then dispatches
 * theme:cart:change + theme:cart:reload and opens the cart drawer — the same recipe as
 * sections/fs-four-steps.liquid. assets/cart-drawer.js also intercepts the fetch and
 * re-renders its Liquid, which is what surfaces the automatic discount on the line.
 */
(function () {
  if (window.__fsCompanionOffer) return;
  window.__fsCompanionOffer = true;

  function setError(root, msg) {
    var errEl = root && root.querySelector('[data-fs-companion-error]');
    if (!errEl) return;
    errEl.textContent = msg;
    errEl.hidden = false;
    setTimeout(function () { errEl.hidden = true; }, 6000);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fs-companion-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;

    var items = [];
    try {
      items = JSON.parse(btn.getAttribute('data-fs-companion-items') || '[]');
    } catch (err) {
      items = [];
    }
    items = items
      .filter(function (i) { return i && i.id; })
      .map(function (i) { return { id: parseInt(i.id, 10), quantity: parseInt(i.quantity, 10) || 1 }; });
    if (!items.length) return;

    var root = btn.closest('[data-fs-companion]');
    var errEl = root && root.querySelector('[data-fs-companion-error]');
    if (errEl) errEl.hidden = true;

    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    var routes = (window.theme && window.theme.routes) || {};
    var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
    var cartUrl = (routes.cart || '/cart') + '.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) { throw data; });
        }
        return res.json();
      })
      .then(function () {
        return fetch(cartUrl).then(function (res) { return res.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        var drawer = document.querySelector('[data-drawer="drawer-cart"]');
        if (drawer) {
          drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
        }
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        var msg = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
        if (typeof msg !== 'string') msg = 'Something went wrong. Please try again.';
        setError(root, msg);
      });
  });
})();
